export default from './Survey';



// WEBPACK FOOTER //
// ./src/components/NonAuthSurveyPage/components/Survey/index.js